export class OnlineVerification {
  private el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
  }

  init(): void {
    const form = this.el.querySelector("form");
    if (form) {
      form.setAttribute("method", "GET");
    }
  }

  destroy(): void {}

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="online-verification"]')
      .forEach((el) => {
        new OnlineVerification(el).init();
      });
  }
}
